import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import {
  AppBar, Toolbar, Typography, Box, IconButton, Menu, MenuItem,
  Popper, ClickAwayListener, useTheme
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import {
  getSuperAdminProfileAPI,
} from "./Servicefile/ProfileService.jsx";
import adminWebSocketService from '../context/AdminWebSocketService';
const Navbars = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [searchPopperAnchorEl, setSearchPopperAnchorEl] = useState(null);
  const [adminImage, setAdminImage] = useState(null);
  const searchPopperRef = useRef(null);

  useEffect(() => {
    const fetchAdminProfile =
      async () => {
        try {
          const data =
            await getSuperAdminProfileAPI();

          if (
            data &&
            data.adminImage
          ) {
            setAdminImage(
              data.adminImage
            );
          }

        } catch (err) {
          console.error(
            "Error fetching admin profile:",
            err
          );
        }
      };

    fetchAdminProfile();

  }, []);

  const handleProfileMenuOpen = (event) => {

    handleSearchPopperClose();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => setMenuAnchorEl(null);

  const handleSearchPopperToggle = (event) => {
    setSearchPopperAnchorEl(searchPopperAnchorEl ? null : event.currentTarget);
  };

  const handleSearchPopperClose = () => setSearchPopperAnchorEl(null);

  const handleLogout = () => {
       // Disconnect WebSocket
    adminWebSocketService.disconnect();
    localStorage.removeItem("authToken");
    localStorage.removeItem("vendorId");
    handleProfileMenuClose();
    navigate("/");
  };

  const openSearchPopper = Boolean(searchPopperAnchorEl);
  const searchPopperId = openSearchPopper ? 'mobile-search-popper' : undefined;

  return (
    <AppBar position="fixed" elevation={0} sx={{ background: "#B15DC6", zIndex: 1200 }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingX: { xs: 1, sm: 2 } }}>

        <Box display="flex" alignItems="center">
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "#fff",
              fontSize: { xs: "18px", sm: "24px", md: "31px" },
              whiteSpace: 'nowrap'
            }}
          >
            MAAMAA'S
          </Typography>
        </Box>


        <Box display="flex" alignItems="center" gap={{ xs: 0.1, sm: 0.5, md: 1 }}>




          <IconButton
            onClick={handleProfileMenuOpen}
            size="large"
            sx={{ padding: 0 }}
          >
            {adminImage ? (
              <Avatar
                src={adminImage}
                alt="Admin"
                sx={{ width: 36, height: 36 }}
                imgProps={{
                  onError: (e) => (e.target.src = "/default-avatar.png"),
                }}
              />
            ) : (
              <Avatar
                sx={{
                  width: 36,
                  height: 36,
                  bgcolor: "#fff",
                  border: "2px solid #000",
                  color: "#000",
                }}
              >
                <PersonIcon />
              </Avatar>
            )}
          </IconButton>

        </Box>


        <Menu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleProfileMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          slotProps={{
            paper: {
              sx: {
                marginTop: '8px',
                width: "130px",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                borderRadius: "8px",
                zIndex: 1500,
              }
            }
          }}
        >
          <MenuItem onClick={handleLogout} sx={{ fontSize: { xs: '1rem', sm: '0.9rem' } }}>
            Logout
          </MenuItem>
        </Menu>



      </Toolbar>
    </AppBar>
  );
};

export default Navbars;
